<app-header></app-header>
<app-loading-generico [loadingGenerico]="loadingGenerico"></app-loading-generico>
<app-botao-chat></app-botao-chat>


<div class="container py-4">
  <div class="row">
    <div class="col-12">
      <div class="card" style="min-height: 80vh;">
        <app-breadcrumb></app-breadcrumb>
        <h1 class="titulo">Gerenciar ocorrências</h1>
        <form [formGroup]="formFiltro" style="min-height: 100%">
          <div class="painel_filtros_ocorrencia">
            <app-select-one [label]="'Tipo da Ocorrência'"
              class="filtro_tipo_ocorrencia"
              formControlName="idTipoOcorrencia"
              (valueChanges)="onChangeTipoOcorrencia($event)"
              [collection]="tiposOcorrencias"
              [panelWidth]="'562px'">
            </app-select-one>
            <app-select-one [label]="'Situação'"
              class="filtro_situacao"
              formControlName="idSituacao"
              (valueChanges)="onChangeSituacao($event)"
              [collection]="situacoes"
              [panelWidth]="'220px'">
            </app-select-one>
            <div class="filtro_data">
              <mat-form-field appearance="outline" class="campo-data">
                <mat-label class="mat-label-text">Data Inicial</mat-label>
                <div matPrefix class="input-icone">
                  @if ((!formFiltro.get('dataInicial').errors) && (formFiltro.get('dataInicial').touched && formFiltro.get('dataInicial').dirty)) {
                    <i class="fa fa-check-circle fa-lg check" aria-hidden="true"></i>
                  }
                  @if ((formFiltro.get('dataInicial').errors) && (formFiltro.get('dataInicial').touched && formFiltro.get('dataInicial').dirty)) {
                    <i class="fa fa-times-circle fa-lg error" aria-hidden="true"></i>
                  }
                </div>
                <input
                  matInput
                  type="text"
                  id="dataInicial"
                  dateMask [matDatepicker]="data_inicial_picker"
                  formControlName="dataInicial"

                  (blur)="verificarDatas()"
                  (change)="verificarDatas()"
                  (dateChange)="verificarDatas()"
                  />
                <mat-datepicker-toggle matSuffix [for]="data_inicial_picker">
                  <mat-icon matDatepickerToggleIcon><app-icon-calendar></app-icon-calendar></mat-icon>
                </mat-datepicker-toggle>
                <mat-datepicker #data_inicial_picker></mat-datepicker>
                <mat-error>{{ formFiltro.get('dataInicial').errors?.message }}</mat-error>
              </mat-form-field>
            </div>
            <div class="filtro_data">
              <mat-form-field appearance="outline"  class="campo-data">
                <mat-label class="mat-label-text">Data Final</mat-label>
                <div matPrefix class="input-icone">
                  @if ((!formFiltro.get('dataFinal').errors) && (formFiltro.get('dataFinal').touched && formFiltro.get('dataFinal').dirty)) {
                    <i class="fa fa-check-circle fa-lg check" aria-hidden="true"></i>
                  }
                  @if ((formFiltro.get('dataFinal').errors) && (formFiltro.get('dataFinal').touched && formFiltro.get('dataFinal').dirty)) {
                    <i class="fa fa-times-circle fa-lg error" aria-hidden="true"></i>
                  }
                </div>
                <input
                  matInput
                  type="text"
                  id="dataFinal"
                  formControlName="dataFinal"
                  dateMask [matDatepicker]="data_final_picker"

                  (blur)="verificarDatas()"
                  (change)="verificarDatas()"
                  (dateChange)="verificarDatas()"
                  />
                <mat-datepicker-toggle matSuffix [for]="data_final_picker">
                  <mat-icon matDatepickerToggleIcon><app-icon-calendar></app-icon-calendar></mat-icon>
                </mat-datepicker-toggle>
                <mat-datepicker #data_final_picker></mat-datepicker>
                <mat-error>{{ formFiltro.get('dataFinal').errors?.message }}</mat-error>
              </mat-form-field>
            </div>
            <div class="filtro_numero">
              <mat-form-field appearance="outline" class="campo-busca-numero">
                <div matPrefix class="input-icone">
                  @if (formFiltro.get('numero').value && (!formFiltro.get('numero').errors) && (formFiltro.get('numero').touched && formFiltro.get('numero').dirty)) {
                    <i class="fa fa-check-circle fa-lg check" aria-hidden="true"></i>
                  }
                  @if (formFiltro.get('numero').value && (formFiltro.get('numero').errors) && (formFiltro.get('numero').touched && formFiltro.get('numero').dirty)) {
                    <i class="fa fa-times-circle fa-lg error" aria-hidden="true"></i>
                  }
                </div>
                <mat-label class="mat-label-text">Busque por um número</mat-label>
                <input matInput type="text" formControlName="numero" somenteNumeros (change)="verificarNumero()"/>
                <button
                  type="button"
                  matSuffix
                  >
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 33 33"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M15.3211 4.69377C9.43009 4.69377 4.65446 9.46939 4.65446 15.3604C4.65446 21.2515 9.43009 26.0271 15.3211 26.0271C21.2122 26.0271 25.9878 21.2515 25.9878 15.3604C25.9878 9.46939 21.2122 4.69377 15.3211 4.69377ZM1.98779 15.3604C1.98779 7.99664 7.95733 2.0271 15.3211 2.0271C22.6849 2.0271 28.6545 7.99664 28.6545 15.3604C28.6545 22.7242 22.6849 28.6938 15.3211 28.6938C7.95733 28.6938 1.98779 22.7242 1.98779 15.3604Z"
                      fill="#878787"
                      />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M23.0448 23.0844C23.5655 22.5637 24.4097 22.5637 24.9304 23.0844L30.9304 29.0844C31.4511 29.6051 31.4511 30.4493 30.9304 30.97C30.4097 31.4907 29.5655 31.4907 29.0448 30.97L23.0448 24.97C22.5241 24.4493 22.5241 23.6051 23.0448 23.0844Z"
                      fill="#878787"
                      />
                  </svg>
                </button>
              </mat-form-field>
              <mat-error>{{ formFiltro.get('numero').errors?.message }}</mat-error>
            </div>
          </div>
          <div class="filtro_botao">
            <button
              type="button"
              id="btnFiltrarOcorrencias"
              style="height: 43px; color: var(--primary-color);"
              mat-button
              matPrefix
              [disabled]="formFiltro.invalid"
              class="text-rigth btn botao-outline w-auto"
              (click)="getApiData()"
              >
              <app-icon-filter></app-icon-filter>
              FILTRAR
            </button>
            @if (verificarFiltros()) {
              <button
                type="button"
                class="filtro_limpar btn-icon"
                (click)="limparFiltros()"
                >
                LIMPAR FILTROS
              </button>
            }
          </div>
        </form>
        @if ((resources && resources.length == 0)) {
          <app-sem-resultados
            titulo="Nenhuma ocorrência encontrada."
            subtitulo="No momento você não tem nenhuma ocorrência criada, você pode criar uma nova ocorrência a qualquer momento.">
          </app-sem-resultados>
        }
        @if ((resources && resources.length > 0)) {
          <div class="painel_com_ocorrencias">
            <div class="titulo_resultado">
              Solicitações
            </div>
            <table class="table table-hover border-bottom" aria-describedby="table que lista as ocorrencias">
              <thead>
                <tr>
                  <th scope="col">NÚMERO</th>
                  <th scope="col">EMISSÃO</th>
                  <th scope="col">RESUMO</th>
                  <th scope="col">TIPO</th>
                  <th scope="col">SITUAÇÃO</th>
                  <th scope="col">ENCERRADA</th>
                  <th scope="col"></th>
                </tr>
              </thead>
              <tbody>
                @for (o of resources | paginate: { id: 'paginacaoOcorrencias', itemsPerPage: pagination.pageSize , currentPage: pagination.currentPagePaginator, totalItems: pagination.totalElements}; track o) {
                  <tr
                    >
                    <td>{{o.numeroOcorrencia}}</td>
                    <td>{{o.dataHoraEmissao}}</td>
                    <td>{{o.resumo}}</td>
                    <td>{{o.tipoOcorrencia}}</td>
                    <td>{{o.situacao}}</td>
                    <td>{{o.dataHoraEncerramento}}</td>
                    <td class="text-center" data-bs-toggle="tooltip" data-placement="top"
                      title="Clique para detalhar o pedido">
                      <button
                        type="button"
                        class="btn-icon"
                        (click)="buttonTableClick(o.numeroOcorrencia)"
                        aria-label="Detalhar pedido"
                        >
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 32 33"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          >
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M11.057 25.7606C11.5777 26.2813 12.4219 26.2813 12.9426 25.7606L20.9426 17.7606C21.4633 17.2399 21.4633 16.3957 20.9426 15.875L12.9426 7.87498C12.4219 7.35428 11.5777 7.35428 11.057 7.87498C10.5363 8.39568 10.5363 9.2399 11.057 9.7606L18.1142 16.8178L11.057 23.875C10.5363 24.3957 10.5363 25.2399 11.057 25.7606Z"
                            fill="#008060"
                            />
                        </svg>
                      </button>
                    </td>
                  </tr>
                }
              </tbody>
            </table>
            @if (totalRegistros>0) {
              <div class="paginacao-padding">
                <app-paginacao
                  paginacaoId="paginacaoOcorrencias"
                  itensPorPaginaId="itensPorPaginaOcorrencia"
                  [pageSize]="pagination.pageSize"
                  [currentPage]="pagination.currentPagePaginator"
                  [totalItems]="totalRegistros"
                  [opcoesTamanho]="[
                    { name: '5 REGISTROS', value: '5' },
                    { name: '10 REGISTROS', value: '10' },
                    { name: '50 REGISTROS', value: '50' }
                  ]"
                  (pageChange)="getPage($event)"
                  (pageSizeChange)="pagination.pageSize = $event; getApiData()">
                </app-paginacao>
              </div>
            }
          </div>
        }
        <div id="botoes">
          <button id="btnNovaOcorrencia" class="botao-padrao btn-grande-verde" (click)="novaOcorrencia()">NOVA OCORRÊNCIA
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
<app-footer></app-footer>
